import { render, staticRenderFns } from "./approvalConfiguration.vue?vue&type=template&id=c3ac158c&scoped=true&"
import script from "./approvalConfiguration.vue?vue&type=script&lang=js&"
export * from "./approvalConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./approvalConfiguration.vue?vue&type=style&index=0&id=c3ac158c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ac158c",
  null
  
)

export default component.exports